import React, { useState } from 'react'

/*
 * Password field with a show/hide toggle. Renders the same <input> the
 * auth stylesheet already styles, so it drops into any of the forms.
 */

const EyeIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
        <circle cx="12" cy="12" r="3.4" />
    </svg>
);

const EyeOffIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M9.9 5.9A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-3.3 4.1" />
        <path d="M6.4 7.6A17 17 0 0 0 2.5 12S6 18.5 12 18.5a9.4 9.4 0 0 0 3.7-.76" />
        <path d="M9.6 9.6a3.4 3.4 0 0 0 4.8 4.8" />
        <path d="M4 4 20 20" />
    </svg>
);

const PasswordInput = ({
    name,
    value,
    onChange,
    placeholder,
    autoComplete = 'current-password',
    disabled = false,
}) => {
    const [visible, setVisible] = useState(false);

    return (
        <div className="password-field">
            <input
                type={visible ? 'text' : 'password'}
                className="has-toggle"
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoComplete={autoComplete}
                disabled={disabled}
            />
            <button
                type="button"
                className="password-toggle"
                onClick={() => setVisible((v) => !v)}
                aria-label={visible ? 'Hide password' : 'Show password'}
                aria-pressed={visible}
                disabled={disabled}
            >
                {visible ? <EyeOffIcon /> : <EyeIcon />}
            </button>
        </div>
    );
};

export default PasswordInput
